module.exports = __webpack_public_path__ + "media/src/images/icons/talk-comment-cfee7e743af6485cf9198e3c6783a20f.svg";